import { render, staticRenderFns } from "./Assesment.vue?vue&type=template&id=45f66271"
import script from "./Assesment.vue?vue&type=script&lang=js"
export * from "./Assesment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports